import { useFormik } from "formik";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import * as Yup from "yup";
import { useTranslation } from "@i18n/hooks";
import {
	type AddExternalLicenseFormState,
	type AddExternalLicenseProps,
} from "./add-external-license-form.interface";
import { DefaultTextFieldComponent } from "../../../../components/DefaultTextInput";
import { ValidatedField } from "../../../../components/ValidatedField";

export const AddExternalLicenseForm = ({
	onSubmitCallback,
	addExternalLicenseDialogVisible,
	onHideToggle,
}: AddExternalLicenseProps) => {
	const { t } = useTranslation(["common", "validation"]);

	const formik = useFormik<AddExternalLicenseFormState>({
		enableReinitialize: false,
		initialValues: {
			name: t("common:externalLicenses.newLicense"),
			code: "",
		},
		onSubmit: (values, { setSubmitting }) => {
			onSubmitCallback(values);
			setSubmitting(false);
			formik.resetForm();
		},
		validationSchema: Yup.object().shape({
			name: Yup.string().required(t("validation:externalLicenseNameFill")),
			code: Yup.string().required(t("validation:externalLicenseCodeFill")),
			usageInformation: Yup.string().optional(),
			validUntil: Yup.date().optional(),
			daysOfValidityAfterIssuing: Yup.number().optional(),
		}),
	});

	return (
		<>
			<Dialog
				header={t("common:externalLicenses.dialogHeader")}
				visible={addExternalLicenseDialogVisible}
				maximizable
				modal
				style={{ width: "50vw" }}
				onHide={() => {
					onHideToggle(false);
				}}
			>
				<form onSubmit={formik.handleSubmit} className="p-fluid">
					<ValidatedField<AddExternalLicenseFormState, string>
						name={"name"}
						label={t("common:table.name")}
						component={DefaultTextFieldComponent}
						formikConfig={formik}
					/>
					<ValidatedField<AddExternalLicenseFormState, string>
						name={"code"}
						label={t("common:externalLicenses.code")}
						component={DefaultTextFieldComponent}
						formikConfig={formik}
					/>

					<Button
						disabled={Object.entries(formik.touched).length === 0}
						type="submit"
						label={t("common:externalLicenses.create")}
						className="mt-2"
					/>

					<Button
						type="button"
						onClick={() => {
							onHideToggle(false);
						}}
						label={t("common:actions.back")}
						className="p-button-secondary mt-2"
					/>
				</form>
			</Dialog>
		</>
	);
};
